import { render } from "./MypageLeftTab.vue?vue&type=template&id=48816979&scoped=true"
import script from "./MypageLeftTab.vue?vue&type=script&lang=js"
export * from "./MypageLeftTab.vue?vue&type=script&lang=js"

import "@/assets/css/components/Mypage/mypage_leftTab.css?vue&type=style&index=0&id=48816979&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48816979"]])

export default __exports__